module.exports = __webpack_public_path__ + "img/icon-avion.01877fc7.svg";